<!-- Liste des adresses du profil -->
<div class="pt-2">
    <list-view [liste]="listeAdresseProfil"></list-view>
</div>